
  <div class="row">
    <section *ngIf="cardComponents[0]?.apiFailed && !cardComponents[0]?.parsingError" class="error-wrapper" >
      <f-alert variant="error">
        <p>There was a problem loading the data. 
            <a (click)="onRefreshClickAction()">Try again </a></p> 

      </f-alert>
  </section>

  <section *ngIf="cardComponents[0]?.parsingError" class="error-wrapper" >
      <f-alert variant="error">
        <p>There is an issue with the configuration of the client data.  Please contact the Support Team for assistance.</p> 

      </f-alert>
  </section>
    <div class="col-md-12 hn-card" *ngIf="!cardComponents[0]?.apiFailed && !cardComponents[0]?.parsingError" >
      <div class="hn-card-left">
        <h6>List of services</h6>
        <ul class="service-list">
          <li *ngFor="let service of serviceList" [class.active]="checkSelectedService(service)"><button type="button" (click)="viewService(service)" >{{ service }}</button></li>
        </ul>
      </div>
      <div class="hn-card-right">
        <app-dynamic-content [cardData]="updateCurrentCards()"></app-dynamic-content>
      </div>
    </div>
</div>  